import { __ } from '@wordpress/i18n';
import {InspectorControls} from '@wordpress/block-editor';
import {VayuBlocksAdvancePanel} from '@vayu-blocks/advance-panel';
import SlideSettings from './video.js';
import OverlaySettings from './overlay.js';
import { VayuBlocksHeaderTab, usePanelSettings } from '@vayu-blocks';

const panelKeys = [
	'slide-video',
	'slide-effect',
	'overlay-poster',
	'overlay-lightbox',
	'overlay-button',
	'overlay-frame',
	'overlay-position',
];

const initialPanels = {
	slide: 'slide-video',
	overlay: '',
	advanced: ''
};

const PanelSettings = ({ attributes, setAttributes, isSelected, clientId }) => {

	const {tab, setTab, openPanels, onTogglePanel } = usePanelSettings({ clientId, panelKeys, initialPanels, defaultTab: 'slide'});

	const panelOptions = [
	{
			label: __('Video', 'vayu-blocks'),
			value: 'slide',
			icon: 'video',
		},
		{
			label: __('Poster', 'vayu-blocks'),
			value: 'overlay',
			icon: 'colorwand',
		},
		...(attributes.parentBlock !== 'vayu-blocks/advance-slider'
			? [
					{
						label: __('Advanced', 'vayu-blocks'),
						value: 'advanced',
						icon: 'colorpalette',
					},
			  ]
			: []),
	];
	
	const tabComponents = {
		slide: <SlideSettings attributes={attributes} setAttributes={setAttributes} clientId={clientId} openPanels={openPanels} onTogglePanel={onTogglePanel}/>,
		overlay: <OverlaySettings attributes={attributes} setAttributes={setAttributes} openPanels={openPanels} onTogglePanel={onTogglePanel}/>,
		advanced: <VayuBlocksAdvancePanel attributes={attributes} setAttributes={setAttributes} clientId={clientId} video={true} openPanels={openPanels} onTogglePanel={onTogglePanel}/>,
	};

    return (
		<>
			{isSelected && (
				<InspectorControls>
					<div className='th-block-ins th-button-panel'>

						<VayuBlocksHeaderTab 
							value={ tab }
							options={panelOptions}
							onChange={ setTab }
						/>

						{tabComponents[tab]}

					</div>
				</InspectorControls>  
			)}

    	</>
	);
}

export default PanelSettings;